import styled from 'styled-components';

// Import styles
import { flex } from 'components/styles';

export const Wrapper = styled.div`
	position: relative;
	margin: 0 0.5rem 0 1rem;
`;

export const Content = styled.div`
	position: absolute;
	bottom: 5.5rem;
	left: 50%;
	transform: translateX(-50%);
	padding: 1.2rem 1.8rem;
	background: rgba(0, 0, 0, 0.4);
	opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	column-gap: 1.8rem;
	${flex({ jc: 'center', ai: 'flex-start' })}
`;

export const SettingsName = styled.p`
	text-align: center;
	color: ${({ theme }) => theme.grayMedium};
`;

export const List = styled.ul`
	list-style: none;
	${flex()}
	flex-direction: column;
`;

export const ListItem = styled.li`
	font-size: 1.4rem;
	margin-bottom: 0.6rem;
	color: ${({ theme, isSelected }) => (isSelected ? theme.white : theme.gray)};
	transition: all 0.3 ease-in-out;
	cursor: pointer;
	text-transform: capitalize;

	&:hover {
		color: ${({ theme }) => theme.white};
	}
`;
